<template>
  <div>
    <input type="file" @change="change" ref="file" />
    <table>
      <tr v-for="(value, key, index) in hashMap" :key="index">
        <td>{{ key }}</td>
        <td v-for="(v, k, i) in value" :key="i">
          {{ v }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import parseExcel from '../plugins/parseExcel'
export default {
  name: 'test',
  data() {
    return {
      hashMap: {},
    }
  },
  created() {
    this.$get('/test/001').then((resp) => {
      if (resp.data.code == 0) {
        console.log(resp.data.data)
        this.hashMap = resp.data.data
      }
    })
  },
  methods: {
    change(e) {
      var files = e.target.files
      if (files.length > 0) {
        var file = files[0]
        this.$refs.file.value = ''
        parseExcel.load(file).then((json) => {
          console.log(json)
        })
      }
    },
  },
}
</script>